(() => {
  const configElement = document.getElementById('bm-newsletter-locale-data');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const normalize = text => text.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  const translations = new Map(config.text.map(row => [normalize(row.from), row.to]));
  const forms = '[data-testid="klaviyo-form-SJnkxq"],[data-testid="klaviyo-form-WfLxww"],[data-testid="klaviyo-form-UFUqU7"]';
  function translateNode(node) {
    const translated = translations.get(normalize(node.data));
    if (translated && normalize(node.data) !== normalize(translated)) node.data = translated;
  }
  function localize(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) translateNode(walker.currentNode);
    root.querySelectorAll('[placeholder],[aria-label],img[alt]').forEach(element => {
      for (const attribute of ['placeholder','aria-label','alt']) {
        const current = element.getAttribute(attribute);
        const translated = current && translations.get(normalize(current));
        if (translated && current !== translated) element.setAttribute(attribute, translated);
      }
    });
    root.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin === location.origin && /^\/pages\/(datenschutzerklarung|impressum)$/.test(url.pathname)) {
        url.pathname = '/' + config.locale + url.pathname;
        link.href = url.href;
      }
    });
    // These decorative bitmaps contain German promotional copy. Preserve the assets;
    // show the existing form without that image column in non-German draft views.
    root.querySelectorAll('img[src*="cdn.klaviyomail.com"]').forEach(image => {
      const column = image.parentElement?.parentElement;
      if (column && root.contains(column) && column.children.length === 1) {
        column.dataset.bmNewsletterDecorative = 'true';
      }
    });
  }
  function localizeRecentlyViewed() {
    const titles = new Map((config.productTitles || []).map(row => [normalize(row.from).toLowerCase(), row.to]));
    document.querySelectorAll('[id^="RecentlyViewed-"] .grid-product__title').forEach(element => {
      const translated = titles.get(normalize(element.textContent).toLowerCase());
      if (!translated) return;
      element.textContent = translated;
      const link = element.closest('a[href]');
      if (link) {
        const url = new URL(link.href, location.origin);
        if (url.origin === location.origin) {
          url.pathname = '/' + config.locale + url.pathname.replace(/^\/(de|en|es|fr|it|nl)(?=\/products\/)/, '');
          link.href = url.href;
        }
      }
    });
  }
  function scan() {
    localizeRecentlyViewed();
    document.querySelectorAll(forms).forEach(localize);
    // Klaviyo renders the reminder outside the form; translate only its exact newsletter text.
    document.querySelectorAll('button,[role="button"]').forEach(button => {
      const text = normalize(button.textContent);
      if (text === 'SICHERE DIR 15% RABATT!') {
        const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) translateNode(walker.currentNode);
      }
    });
    document.querySelectorAll('[role="dialog"]').forEach(dialog => {
      if (!dialog.querySelector(forms)) return;
      const close = dialog.querySelector('button[aria-label="Close dialog"]');
      if (close) close.setAttribute('aria-label', config.close);
    });
  }
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; scan(); });
  });
  scan();
  observer.observe(document.body, {childList:true,subtree:true,characterData:true});
})();
